<template>
  <div class="public_teacher_policy_interpretation" :class="{'padb': flag}">
    <div class="page_middle">
      <!-- <div class="user_center">
        <div v-if="!isLogin" class="loginInfo">
          <span @click="toLogin()">登录</span> / 
          <span @click="toLogin()">注册</span>
        </div>
        <div v-if="isLogin" class="loginInfo">
          <span>{{user.username}}</span> / 
          <span @click="toLogOut()">退出</span>
        </div>
      </div> -->
      <img src="../img/public_teacher_policy_interpretation/header.png" alt="" class="header_img">

      <div class="box">
        <img src="../img/public_teacher_policy_interpretation/zoom.png" alt="" class="box_left">
        <div class="box_right">
          <div class="title">加入Zoom会议</div>
          <div class="link_con">
            <span>链接：</span>
            <a class="link" href="https://zoom.us/j/97269539123?pwd=TUJheVc4REZFZ3NaanErODRmVmYxQT09" target="_blank">https://zoom.us/j/97269539123?pwd=TUJheVc4REZFZ3NaanErODRmVmYxQT09</a>
            <img src="../img/public_teacher_policy_interpretation/copy.png" alt="" class="copy" @click="copy('https://zoom.us/j/97269539123?pwd=TUJheVc4REZFZ3NaanErODRmVmYxQT09')">
          </div>
          <div class="zi_con">
            会议号：972 6953 9123
          </div>
          <div class="zi_con" style="margin-bottom: 0;">
            密码：777889
          </div>
        </div>
      </div>

      <div class="box">
        <img src="../img/public_teacher_policy_interpretation/中文联盟LOGO.png" alt="" class="box_left">
        <div class="box_right">
          <div class="title">转播地址</div>
          <div class="link_con">
            <span>链接：</span>
            <a class="link" href="https://z.chineseplus.net/special/public_teacher_policy_interpretation.html" target="_blank">https://z.chineseplus.net/special/public_teacher_policy_interpretation.html</a>
            <img src="../img/public_teacher_policy_interpretation/copy.png" alt="" class="copy" @click="copy('https://z.chineseplus.net/special/public_teacher_policy_interpretation.html')">
          </div>
          <img src="../img/public_teacher_policy_interpretation/replay.png" alt="" class="replay" @click="replayFun()">
        </div>
      </div>
    </div>

    <transition name="fade">
      <div id="videoPlayWrapper" v-if="isPlay">
        <div class="videoContent">
          <div class="closeVideo" @click="closeVideo()">×</div>
          <ali-player
          v-if="isPlay"
          :useFlashPrism="false"
          :useH5Prism='true'
          :autoplay="true"
          :isLive="false"
          :rePlay="false"
          :showBuffer="true"
          showBarTime="5000"
          width="80%" 
          height="700px" 
          controlBarVisibility="always"
          :source="currentVideoUrl"></ali-player>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import aliPlayer from './aliplayer'

export default {
  components: {
    aliPlayer
  },
  data () {
    return {
      isLogin: false,
      flag: false,
      user: {
        username: '',
        email: ''
      },
      isPlay: false
    }
  },
  mounted () {
    this.customCheckLogin()
    this.$nextTick(() => {
      this.hasScrollbar()
    })
    window.addEventListener('resize', () => {
      this.$nextTick(() => {
        this.hasScrollbar()
      })
    })
  },
  methods: {
    toLogin() {
      window.location.href =
      this.baseUrl +
      "user/api/login?" +
      "callback=" +
      encodeURIComponent(window.location.href);
    },
    customCheckLogin() {
      this.checkLogin().then(res => {
        if(res.data.success){
            this.isLogin = true
            this.user = res.data.data
        } else {
            this.isLogin = false
        }
      })
    },
    toLogOut() {
      this.$utils.get('/user/api/logout').then(res => {
        if(res.data.success) {
            this.isLogin = false
        }
      })
    },
    replayFun (url, id) {
      // if (!this.isLogin) {
      //   this.toLogin()
      //   return
      // }

      // var data = {
      //   rooms: arr.toString(),
      //   user: this.user.email,
      // }
      // this.$utils.thirdPost('https://mooc-stage.chinesecio.com/api/live/get_user_rooms'+"?time=" + new Date().valueOf(), data, {
      //   headers: {
      //     'Content-Type': 'application/json;charset=UTF-8'
      //   }
      // }).then(res => {
      //   var res = res.data
      //   if (res.code == 0) {

      //   }
      // })
      this.isPlay = true
      this.currentVideoUrl = 'https://pan-chinesecio.oss-cn-beijing.aliyuncs.com/video/%E5%BF%97%E6%84%BF%E8%80%85%E4%BF%9D%E9%99%A9%E7%9B%B8%E5%85%B3.mp4'
    },
    closeVideo() {
      this.isPlay = false
    },
    hasScrollbar () {
      this.flag = document.getElementsByClassName('public_teacher_policy_interpretation')[0].clientHeight > document.body.clientHeight
    },
    copy (obj) {
      if (!document.queryCommandSupported('copy')) {
        throw new Error('document.execCommand method not support copy command')
      }
      const input = document.createElement('input')
      input.style.cssText = 'display: block;opacity: 0;position: absolute;left: -10000px;top: -10000px;z-index: -1;width: 1px;height: 1px;'
      document.body.appendChild(input)
      input.value = obj
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      alert('复制成功！')
    },
  }
}
</script>

<style scoped lang="scss">
.public_teacher_policy_interpretation {
  width: 100%;
  min-height: 100vh;
  background: url('../img/public_teacher_policy_interpretation/background.png') no-repeat center;
  background-size: cover;
  &.padb {
    padding-bottom: 30px;
  }
  .page_middle {
    width: 1200px;
    margin: auto;
    overflow: hidden;
    .user_center {
      overflow: hidden;
      .loginInfo {
        font-size: 18px;
        color: #ffd782;
        float: right;
        margin-top: 30px;
        span {
          cursor: pointer;
        }
      }
    }
    .header_img {
      display: block;
      margin: auto;
      margin-top: 30px;
      margin-bottom: 48px;
    }
    .box {
      width: 100%;
      background-color: #fff;
      box-shadow: 0px 10px 20px 0px 
        rgba(0, 0, 0, 0.3);
      border-radius: 30px;
      padding-left: 77px;
      padding-top: 40px;
      padding-bottom: 40px;
      overflow: hidden;
      margin-bottom: 30px;
      box-sizing: border-box;
      &:last-child {
        margin-bottom: 0;
      }
      .box_left {
        display: block;
        float: left;
      }
      .box_right {
        float: left;
        margin-left: 55px;
        .title {
          font-size: 30px;
          font-weight: bold;
          color: #257be9;
          margin-bottom: 19px;
        }
        .link_con {
          color: #364347;
          font-size: 18px;
          margin-bottom: 20px;
          a {
            color: #009bff;
            text-decoration: underline;
            cursor: pointer;
          }
          .copy {
            margin-left: 10px;
          }
        }
        .zi_con {
          color: #364347;
          font-size: 18px;
          margin-bottom: 20px;
        }
        .replay {
          display: block;
          margin-top: 30px;
          cursor: pointer;
        }
      }
    }
  }
  #videoPlayWrapper {
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 999;
  }
  #videoPlayWrapper .closeVideo {
      position: absolute;
      right: 20px;
      top: 10px;
      font-size: 50px;
      color: #fff;
      cursor: pointer;
  }
  .videoContent {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
  }
  .videoContainer {
      text-align: center;
      width: 100%;
  }
  .videoContainer video {
      width: 62%;
  }
  video::-internal-media-controls-download-button {
      display:none;
  }
  video::-webkit-media-controls-enclosure {
      overflow:hidden;
  }
  video::-webkit-media-controls-panel {
      width: calc(100% + 30px);
  }
}
</style>
